
const state = {
  bathrooms: '',
  bedrooms: '',
  campaign_id: undefined,
  carparks: '',
  comparable_source: 'agency',
  data: {},
  external_link: '',
  image_id: undefined,
  land_area: '',
  notes: '',
  post_code: '',
  price_guide: '',
  property_type: '',
  sold: false,
  sold_date: '',
  state_name: '',
  street_name: '',
  street_number: '',
  suburb_name: '',
  unit_number: '',
}

export const requiredFields = [
  { key: 'bathrooms' },
  { key: 'bedrooms' },
  { key: 'carparks' },
  { key: 'post_code' },
  { key: 'price_guide' },
  { key: 'property_type' },
  { key: 'state_name' },
  { key: 'street_name' },
  { key: 'street_number' },
  { key: 'suburb_name' },
]

export default state
